import { render, staticRenderFns } from "./CmsRegistSuggest.vue?vue&type=template&id=4a0731e0&scoped=true&"
import script from "./CmsRegistSuggest.vue?vue&type=script&lang=js&"
export * from "./CmsRegistSuggest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0731e0",
  null
  
)

export default component.exports